import { c as _c } from "react/compiler-runtime";
import { useSearchParam } from "#/shared/hooks";
import { usePlaygroundViewContext } from "../context/PlaygroundViewContext";
import { PLAYGROUND_VIEW_PARAM_OPTIONS, type PlaygroundView, type PlaygroundViewParam } from "../model/playgroundView";
export type { PlaygroundView } from "../model/playgroundView";
export { isPlaygroundView } from "../model/playgroundView";

/**
 * Returns the playground view param. When inside PlaygroundViewProvider,
 * updates are instant (shared React state). Otherwise falls back to useSearchParam
 * (syncs via router, so updates may lag until router propagates).
 */
export const usePlaygroundViewParam = () => {
  const $ = _c(4);
  const context = usePlaygroundViewContext();
  const [view, setView] = useSearchParam("view", PLAYGROUND_VIEW_PARAM_OPTIONS);
  let t0;
  if ($[0] !== context || $[1] !== setView || $[2] !== view) {
    t0 = context ?? {
      view,
      setView
    };
    $[0] = context;
    $[1] = setView;
    $[2] = view;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return t0;
};